import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { isString } from 'lib/Helpers';

import SortingArrows from '../../../SortingArrows';
import * as styles from './SortableHeaderCellRenderer.scss';

/**
 * Reusable SortableHeaderCellRenderer Component for <Table />
 * @function SortableHeaderCellRenderer
 * @param {Object} props
 * @return {ReactElement}
 */
const SortableHeaderCellRenderer = ({ dataKey, label, sortBy, sortDirection }) => {
  return (
    <div>
      <span
        className={classNames(
          'ReactVirtualized__Table__headerTruncatedText',
          styles.sortableHeaderCellRenderer
        )}
        key={dataKey}
        title={isString(label) ? label : null}
      >
        {label}
      </span>
      <div className={styles.sortingArrows}>
        <SortingArrows
          currentField={dataKey}
          sortBy={sortBy || ''}
          sortDirection={sortDirection || 'ASC'} />
      </div>
    </div>
  );
};

SortableHeaderCellRenderer.propTypes = {
  dataKey: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  sortBy: PropTypes.string,
  sortDirection: PropTypes.string,
};

export default SortableHeaderCellRenderer;
